// Normalização robusta de telefones brasileiros para deduplicação/matching.
// A versão original é sempre preservada no campo `telefone`; esta função
// devolve uma versão apenas-dígitos para comparação segura entre os dois WhatsApps.

export function normalizarTelefoneBr(input: string | null | undefined): string | null {
  if (input == null) return null;
  let d = String(input).replace(/\D/g, '');
  if (!d) return null;
  // remove código do país quando presente
  if (d.startsWith('55') && d.length >= 12) d = d.slice(2);
  // adiciona nono dígito quando faltar (DDD + 8 dígitos = 10)
  if (d.length === 10) d = d.slice(0, 2) + '9' + d.slice(2);
  return d;
}

// Indica se dois números normalizados são considerados o mesmo para matching.
export function telefonesIguais(a: string | null | undefined, b: string | null | undefined): boolean {
  const na = normalizarTelefoneBr(a);
  const nb = normalizarTelefoneBr(b);
  if (!na || !nb) return false;
  // comparação forte só para números completos (>= 10 dígitos)
  if (na.length < 10 || nb.length < 10) return false;
  return na === nb;
}

export function formatarTelefone(input: string | null | undefined): string {
  if (!input) return '—';
  const d = String(input).replace(/\D/g, '');
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return input;
}